<div class="ui-dialog-titlebar ui-widget-header ui-helper-clearfix ui-corner-top">
  <span class="ui-dialog-title">{{'FR.Dialogs.Title.ImportChecklist'|translate}}</span>
  <div class="ui-dialog-titlebar-icons">

    <button (click)="dialogRef.close()" type="button"
      class="btn btn-link ui-dialog-titlebar-icon ui-dialog-titlebar-close ui-corner-all">
      <span class="pi pi-times"></span>
    </button>
  </div>
</div>

<div class="ui-dialog-content ui-widget-content">

  <div class="form-group">
    <label style="display: block;">{{'FR.Forms.Labels.ChecklistType' | translate}}</label>

    
    <p-autoComplete
      appendTo="body"
      (completeMethod)="onComplete($event)"
      (onClear)="onClear()"
      (onSelect)="onSelect($event)"
      [suggestions]="filteredCheckListTypes"
      field="label"
      dropdown
      delay="1000"
      dropdown="true"
      [minLength]="3"
    ></p-autoComplete>

  </div>

</div>

<div class="ui-dialog-footer ui-widget-content">
  <button type="button" class="btn btn-default" (click)="dialogRef.close()">
    {{'FR.Dialogs.Actions.Cancel'|translate}}
  </button>
  <button [disabled]="!selectedChecklistType" type="submit" (click)="dialogRef.close(selectedChecklistType)"
    class="btn btn-primary">
    {{'FR.Dialogs.Actions.Confirm'|translate}}
  </button>
</div>